import { render, staticRenderFns } from "./UpdatePracticeCourt.vue?vue&type=template&id=6f0bf1a6&"
import script from "./UpdatePracticeCourt.vue?vue&type=script&lang=ts&"
export * from "./UpdatePracticeCourt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports